class BurntMtnHeader extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-mobile-menu]');
    this.toggle?.addEventListener('click', () => this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true'));
    this.querySelectorAll('[data-menu-close]').forEach((element) => element.addEventListener('click', () => this.setOpen(false)));
    document.addEventListener('keyup', (event) => { if (event.key === 'Escape') this.setOpen(false); });
  }
  setOpen(open) {
    if (!this.toggle || !this.panel) return;
    this.toggle.setAttribute('aria-expanded', String(open));
    this.panel.hidden = !open;
    document.body.classList.toggle('menu-open', open);
  }
}
customElements.define('burnt-mtn-header', BurntMtnHeader);

class ProductExperience extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form[action*="/cart/add"]');
    this.variantInput = this.querySelector('[name="id"]');
    this.price = this.querySelector('[data-product-price]');
    this.submit = this.querySelector('[type="submit"]');
    this.submitLabel = this.querySelector('[data-submit-label]');
    this.variants = JSON.parse(this.querySelector('[data-variants-json]')?.textContent || '[]');

    this.querySelectorAll('[data-option-select]').forEach((select) => select.addEventListener('change', () => this.updateVariant(select)));
    this.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.addEventListener('click', () => this.selectMedia(button)));
    this.updateVariant();
  }

  selectMedia(button) {
    const target = this.querySelector(`[data-media-id="${button.dataset.mediaTarget}"]`);
    if (!target) return;
    this.querySelectorAll('[data-product-media]').forEach((media) => media.hidden = media !== target);
    this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.setAttribute('aria-current', String(thumb === button)));
  }

  isDiyXl(options) {
    const hasDiy = options.some((option) => /diy/i.test(option));
    const hasXl = options.some((option) => /\bxl\b|xlarge|extra large|28\s*(?:in\.?|x)|36\s*(?:in\.?|x)/i.test(option));
    return hasDiy && hasXl;
  }

  findVariant(options) {
    return this.variants.find((candidate) => !this.isDiyXl(candidate.options) && candidate.options.every((option, index) => option === options[index]));
  }

  findFallbackVariant(options, changedSelect) {
    const allowedVariants = this.variants.filter((variant) => !this.isDiyXl(variant.options));
    if (!changedSelect) return allowedVariants.find((variant) => variant.available) || allowedVariants[0];

    const changedPosition = Number(changedSelect.dataset.optionPosition);
    const matchingChangedValue = allowedVariants.filter((variant) => variant.options[changedPosition] === changedSelect.value);
    const candidates = matchingChangedValue.length ? matchingChangedValue : allowedVariants;
    return candidates.find((variant) => variant.available && variant.options.every((option, index) => index === changedPosition || option === options[index]))
      || candidates.find((variant) => variant.available)
      || candidates[0];
  }

  syncOptionAvailability(selects) {
    const selectedOptions = selects.map((select) => select.value);
    selects.forEach((select, position) => {
      [...select.options].forEach((option) => {
        const candidateOptions = [...selectedOptions];
        candidateOptions[position] = option.value;
        option.disabled = this.isDiyXl(candidateOptions) || !this.findVariant(candidateOptions);
      });
    });
  }

  updateVariant(changedSelect) {
    const selects = [...this.querySelectorAll('[data-option-select]')];
    let options = selects.map((select) => select.value);
    let variant = this.findVariant(options);

    if (!variant) {
      const fallbackVariant = this.findFallbackVariant(options, changedSelect);
      if (fallbackVariant) {
        selects.forEach((select, index) => { select.value = fallbackVariant.options[index]; });
        options = fallbackVariant.options;
        variant = fallbackVariant;
      }
    }

    this.syncOptionAvailability(selects);

    if (!variant) {
      this.variantInput.value = '';
      if (this.price) this.price.textContent = 'Unavailable';
      if (this.submit) this.submit.disabled = true;
      if (this.submitLabel) this.submitLabel.textContent = 'Unavailable';
      return;
    }

    this.variantInput.value = variant.id;
    if (this.price) this.price.textContent = this.formatMoney(variant.price);
    if (this.submit) this.submit.disabled = !variant.available;
    if (this.submitLabel) this.submitLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    if (variant.featured_media_id) {
      const mediaButton = this.querySelector(`[data-gallery-thumb][data-media-target="${variant.featured_media_id}"]`);
      if (mediaButton) this.selectMedia(mediaButton);
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
  }
}
customElements.define('product-experience', ProductExperience);

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); } });
}, { rootMargin: '0px 0px -8% 0px' });
document.querySelectorAll('[data-reveal]').forEach((element) => revealObserver.observe(element));
